import { segmentTrackAction } from 'lib/segment'
import { EVENT } from 'lib/segment/const'
import StateStorage from 'lib/state-storage'
import ShopLanguageMap from 'lib/i18n/shop-language-map'

const shop = StateStorage.getShop()
const id_shop = ShopLanguageMap.getIdShopBySlug(shop)

export const segmentVirtualTryOnProductListClicked = ({
  id_product,
  site_category_name,
  id_site_category,
  list_type,
}) => {
  const data = {
    id_product,
    id_shop,
    site_category_name,
    id_site_category,
    list_type,
  }
  segmentTrackAction(EVENT.virtualTryOnProductListClicked, data)
}

export const segmentVirtualTryOnPDPClicked = ({
  id_product,
  site_category_name,
  id_site_category,
}) => {
  const data = {
    id_product,
    id_shop,
    site_category_name,
    id_site_category,
  }
  segmentTrackAction(EVENT.virtualTryOnPDPClicked, data)
}

export const segmentVirtualTryOnShare = ({
  id_product,
  site_category_name,
  id_site_category,
}) => {
  const data = {
    id_product,
    id_shop,
    site_category_name,
    id_site_category,
  }
  segmentTrackAction(EVENT.virtualTryOnShare, data)
}
